module.exports = __webpack_public_path__ + "e8a1f4968881da8be2af030925c01597.png";